import { CheckoutState } from '../../state';
import { getIsPaymentView } from '../routing';
import { isUserLoggedIn } from './pureSelectors';

export const getHasBuyerInformationAvailable = (state: CheckoutState) =>
    isUserLoggedIn(state) || !getIsPaymentView(state);
